import Label from "./Label";
import { ErrorMessage } from "formik";

export default function Input(props) {
  return (
    <div>
      <Label text={props.label} />
      <input
        autoFocus={props.autoFocus || false}
        type={props.type}
        name={props.name}
        id={props.id}
        autocomplete="off"
        defaultValue={props.defaultValue}
        value={props.value}
        onChange={props.onChange}
        onKeyDown={props?.onKeyDown}
        required={props.required || false}
        disabled={props.disabled || false}
        placeholder={props.placeholder}
        max={props?.maximo}
        min={props?.minimo}
        pattern={props?.pattern}
        onBlur={props?.onBlur}
        className={`shadow-sm mt-1 py-2 px-3 text-xs border focus:outline-none focus:ring-2
        focus:ring-offset-primary focus:border-transparent block w-full
        border-gray-300 rounded-md text-primaryFont ${props.className}`}
      />
      {props.validacion && (
        <ErrorMessage
          name={props.name}
          component="span"
          className="text-xs text-red-600"
        />
      )}
    </div>
  );
};
